import './action-card.scss';

import { PropsWithChildren } from 'react';

import { cn } from '../../utils/helpers';

export type ActionCardProps = PropsWithChildren & {
  className?: string;
  color?: 'negative' | 'warning';
};

/**
 * Action Card
 */
export const ActionCard: React.FC<ActionCardProps> = ({
  color,
  className,
  children,
}) => {
  const colorClass = color
    ? {
        warning: 'ActionCard--warning',
        negative: 'ActionCard--negative',
      }[color]
    : '';

  return (
    <div className={cn(['ActionCard rounded-md', colorClass, className])}>
      {children}
    </div>
  );
};

/**
 * Action Card Header
 */
export const ActionCardHeader: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="ActionCard__header -mb-snug-md">{children}</div>;
};

/**
 * Action Card Body
 */
export const ActionCardBody: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    // <div className="pb-comfy-xs flex justify-between items-center md:pb-comfy-md">
    //   {children}
    // </div>
    <div className="ActionCard__body ">{children}</div>
  );
};

/**
 * Action Card Footer
 *
 * NOTE that this should almsot always take in one or more client components.
 */
export const ActionCardFooter: React.FC<PropsWithChildren> = ({ children }) => {
  // flex gap-comfy-sm lg:gap-comfy-md"
  return <div className="ActionCard__footer">{children}</div>;
};
